import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/features/etf-overlap/constants/copy";
const I18n = I18nUtil.createScoped(Translations);
/**
 * ETF 重叠分析的跨 Slice 共享文案（EDG-561）。
 *
 * 文案已走 `I18n.t(...)`，词表在 `src/translate/`（只读，经 `pnpm run scan` 生成）。
 * 测试里请引用这些常量，不要把英文原文写死当断言。
 */

/** 回显气泡 / Brief 入口 / Invest 入口 / 推荐问题首条共用的问句（PRD 逐字） */
export const ETF_OVERLAP_QUESTION = I18n.t("How much do my funds overlap?");

/** SC-03 连账户引导页（PRD 逐字，直引号）。 */
export const ETF_OVERLAP_PROMPT_COPY = {
  kicker: I18n.t("Signed in"),
  title: I18n.t("Let me look inside your funds."),
  body: I18n.t(
    "I'll open every fund you hold and show you which companies you're buying more than once.",
  ),
  trust: I18n.t("Read-only. I never move money."),
  connect: I18n.t("Connect your broker"),
  upload: I18n.t("Upload a screenshot instead"),
  back: I18n.t("Go back"),
} as const;

/** SC-04 引导弹窗（PRD 逐字，直撇号）。 */
export const ETF_OVERLAP_GUIDE_COPY = {
  exampleLabel: I18n.t("Example · VOO + VTI"),
  exampleValue: "85%",
  exampleSuffix: I18n.t("overlap"),
  title: I18n.t("Let's see how much your funds overlap."),
  body: I18n.t(
    "Connect your broker, read-only, and I'll show you which of your funds are buying the same companies. A screenshot works too.",
  ),
  connect: I18n.t("Connect your broker"),
  upload: I18n.t("Upload a screenshot instead"),
} as const;

/** SC-19 Invest · Portfolio 快捷入口卡文案；与 `ETF_OVERLAP_QUESTION` 同一句。 */
export const ETF_OVERLAP_ENTRY_CARD_TEXT = ETF_OVERLAP_QUESTION;

/**
 * 失败消息识别用的**英文原句**（PRD S4.3 / SC-14）。后端以普通文本交付失败话术、没有类型标记，
 * 前端只在埋点需要时靠这些句子识别；这些常量**不**走 I18n（匹配不能受语言影响），
 * 因此刻意不包 `I18n.t`。后端若返回繁中话术，匹配需改为后端下发 `reason`（manifest 与后端核对项）。
 */
export const OVERLAP_FAILURE_SENTENCES = {
  blurry: "This one's too blurry for me to read the numbers.",
  cropped: "I can see the top of your list but not the rest.",
  no_positions: "I can see a balance, but not what's inside it.",
  not_holdings: "This doesn't look like a holdings page.",
  computeError: "Something on my end stopped the overlap check.",
} as const;
